(ns frontend.ui.page.lp-portal.report.controller
  (:require
   [frontend.state.current-session :as session]
   [frontend.ui.component.lp-portal.report.body.real-estate.topo-maps :as topo-maps]
   [frontend.ui.page.lp-portal.report.event :as event]
   [frontend.ui.page.lp-portal.report.view :as view]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.buyout-x.controller :as
    buyout-x-ctl]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.boxi.controller :as boxi-ctl]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.infra.controller :as infra-ctl]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.credit.controller :as credit-ctl]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.credit-v2.controller :as credit-v2-ctl]

   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.controller.core :as re-nre-ctl]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.core :as koke-ctl]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.controller :as resi-ctl]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi-v2.controller :as resi-ctl-v2]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller :as stockholm-living-ctl]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.controller.core :as
    hotel-ctl]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel-v2.controller :as
    hotel-ctl-v2]

   [frontend.ui.component.lp-portal.report.body.feeder.feeder.controller :as feeder-ctl]
   [frontend.ui.component.lp-portal.report.body.feeder.endowment.controller :as endowment-ctl]

   [frontend.ui.component.lp-portal.report.body.private-equity.holding.new-investment-company.controller
    :as ctl-investment]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.infra-company.controller :as
    ctl-infra]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.credit-company.controller :as
    ctl-credit]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.company-exit.controller :as
    ctl-exit-company]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.company.controller :as
    ctl-pe-company]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.special-company.controller
    :as
    ctl-pe-special-company]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.property.controller :as
    ctl-property]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.property.controller-esg :as
    ctl-property-esg]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.property.controller-properties-esg :as
    ctl-properties-esg]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.hotel.controller :as ctl-hotel]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.hotel.controller-esg :as ctl-hotel-esg]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.hotel.controller-property-esg :as ctl-hotel-property-esg]

   [frontend.ui.component.lp-portal.report.body.real-estate.holding.resi.controller :as ctl-resi]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.resi.controller-esg :as ctl-resi-esg]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.resi.controller-property-esg :as ctl-resi-property-esg]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.resi.controller-stockholm-living :as
    ctl-stockholm-living-property]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.koke.controller :as ctl-koke]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.koke.controller-esg :as ctl-koke-esg]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.koke.controller-property-esg :as ctl-koke-property-esg]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.re-new-investment.controller :as
    ctl-re-new-investment]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.re-exit-property.controller :as
    ctl-re-exit-property]
   [frontend.ui.component.lp-portal.report.body.invest-europe.fund.controller :as
    invest-europe-fund-ctl]
   [frontend.ui.component.lp-portal.report.body.voima.fund.controller :as voima-fund-ctl]
   [frontend.ui.component.lp-portal.report.body.sparkmind.fund.controller :as sparkmind-fund-ctl]
   [frontend.ui.component.lp-portal.report.body.innovestor.fund.controller :as innovestor-fund-ctl]
   [frontend.ui.component.lp-portal.report.body.lifeline.fund.controller :as lifeline-fund-ctl]
   [frontend.ui.component.lp-portal.report.body.lifeline.fund.fund-vi.controller :as lifeline-fund-vi-ctl]
   [frontend.ui.page.lp-portal.report.sub :as sub]
   [re-frame.core :as rf]
   [common.util :as cu]
   [common.schema.entities.lp-portal.lp-report-holding :as lp-report-holding]

   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.controller :as ctl-ie-holding]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.new-investment.controller :as
    ctl-ie-new-investment]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.exit.controller :as ctl-ie-exit]
   [frontend.ui.component.lp-portal.report.body.sparkmind.holding.controller :as sparkmind-holding-ctl]
   [frontend.ui.component.lp-portal.report.body.innovestor.holding.controller :as ctl-innovestor-holding]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.controller :as natural-capital-ctl]
   [frontend.ui.component.lp-portal.report.body.lifeline.holding.controller :as lifeline-holding-ctl]))

(defn holding-report->ui-data
  [{:keys [report images]}]
  (let [{:lp-report-holding/keys [template-type data editable-data]} report
        data-ctx {:dynamic-data editable-data
                  :report-id    (:db/id report)
                  :images       images
                  :map-topo     topo-maps/highmaps-nordic-countries-topo
                  :report-data  (merge {:holding-name (:lp-report-holding/name report)}
                                       data)
                  :accounts     @session/accounts} ;; TODO better implementation for seeing which account has added manual data?
        ui-data
        (case template-type
          :lp-report-holding-template.capman/private-equity-company (ctl-pe-company/->ui-data data-ctx)
          :lp-report-holding-template.capman/private-equity-special-situations (ctl-pe-special-company/->ui-data
                                                                                data-ctx)
          :lp-report-holding-template.capman/private-equity-exit-company (ctl-exit-company/->ui-data data-ctx)
          :lp-report-holding-template.capman/private-equity-investment-company (ctl-investment/->ui-data data-ctx)
          :lp-report-holding-template.capman/natural-capital-investment (ctl-investment/->ui-data data-ctx)
          :lp-report-holding-template.capman/infra-company (ctl-infra/->ui-data data-ctx)
          :lp-report-holding-template.capman/credit-company (ctl-credit/->ui-data data-ctx) 

          :lp-report-holding-template.capman/real-estate-property-nre (ctl-property/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-property-nre-esg (ctl-property-esg/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-portfolio-nre-esg (ctl-properties-esg/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-portfolio-hotels (ctl-hotel/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-portfolio-hotels-esg (ctl-hotel-esg/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-property-hotels-esg (ctl-hotel-property-esg/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-portfolio-koke (ctl-koke/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-portfolio-koke-esg (ctl-koke-esg/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-property-koke-esg (ctl-koke-property-esg/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-portfolio-resi (ctl-resi/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-portfolio-resi-esg (ctl-resi-esg/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-property-resi-esg (ctl-resi-property-esg/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-property-stockholm-living (ctl-stockholm-living-property/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-new-investment (ctl-re-new-investment/->ui-data data-ctx)
          :lp-report-holding-template.capman/real-estate-exit-property (ctl-re-exit-property/->ui-data data-ctx)

          :lp-report-holding-template.invest-europe/holding (ctl-ie-holding/->ui-data data-ctx)
          :lp-report-holding-template.invest-europe/new-investment (ctl-ie-new-investment/->ui-data data-ctx)
          :lp-report-holding-template.invest-europe/exit (ctl-ie-exit/->ui-data data-ctx)

          :lp-report-holding-template.sparkmind/private-equity-company (sparkmind-holding-ctl/->ui-data data-ctx)

          :lp-report-holding-template.innovestor/holding (ctl-innovestor-holding/->ui-data data-ctx)
          :lp-report-holding-template.innovestor/technology-fund-holding (ctl-innovestor-holding/->tech-holding-ui-data data-ctx)
          :lp-report-holding-template.innovestor/technology-fund-holding-v2 (ctl-innovestor-holding/->tech-holding-ui-data data-ctx)
          :lp-report-holding-template.lifeline/holding (lifeline-holding-ctl/->holding-ui-data data-ctx)
          :lp-report-holding-template.lifeline/exited-holding (lifeline-holding-ctl/->holding-ui-data data-ctx)
          


          (do
            (js/console.error "Cannot resolve HOLDING template : " report)
            nil))]
    ui-data
    #_{:holding-template-type template-type
       :holding-ui-data       ui-data}))

(defn report->fund-ui-data
  [{:keys [report images]}]
  (when report
    (let [{:lp-report/keys [template-type data editable-data editable-report-images]} report
          images-by-id (cond
                         (map? images)
                         images

                         (sequential? images)
                         (->> images
                              (keep (fn [image]
                                      (when-let [image-id (:db/id image)]
                                        [image-id image])))
                              (into {}))

                         :else
                         {})
          data-ctx {:dynamic-data editable-data
                    :dynamic-report-images editable-report-images
                    :images       images-by-id
                    :map-topo     topo-maps/highmaps-nordic-countries-topo
                    :report-data  data
                    :accounts     @session/accounts}
          ui-data
          (case template-type
            :lp-report-template/materials-only nil
            :lp-report-template.capman/private-equity-fund-buyout-x (buyout-x-ctl/->ui-data
                                                                     data-ctx)
            :lp-report-template.capman/private-equity-fund-buyout-x-v2 (buyout-x-ctl/->ui-data
                                                                        data-ctx)
            :lp-report-template.capman/private-equity-fund-boxi (boxi-ctl/->ui-data data-ctx)
            :lp-report-template.capman/infra-fund (infra-ctl/->ui-data data-ctx)
            :lp-report-template.capman/credit-fund (credit-ctl/->ui-data data-ctx)
            :lp-report-template.capman/credit-fund-v2 (credit-v2-ctl/->ui-data data-ctx)
            :lp-report-template.capman/credit-fund-v2-capman (credit-v2-ctl/->ui-data data-ctx)
            :lp-report-template.capman/credit-fund-v3 (credit-v2-ctl/->ui-data-v3 data-ctx)
            :lp-report-template.capman/dasos-natural-capital (natural-capital-ctl/->ui-data data-ctx)
            :lp-report-template.capman/dasos-natural-capital-FIN (natural-capital-ctl/->ui-data data-ctx)

            :lp-report-template.capman/real-estate-fund-hotels (hotel-ctl/->ui-data data-ctx)
            :lp-report-template.capman/real-estate-fund-hotels-v2 (hotel-ctl-v2/->ui-data data-ctx)
            :lp-report-template.capman/real-estate-fund-hotels-v3 (hotel-ctl-v2/->ui-data-v3 data-ctx)
            :lp-report-template.capman/real-estate-fund-koke (koke-ctl/->ui-data data-ctx)
            :lp-report-template.capman/real-estate-fund-nre (re-nre-ctl/->ui-data data-ctx)
            :lp-report-template.capman/real-estate-fund-resi (resi-ctl/->ui-data data-ctx)
            :lp-report-template.capman/real-estate-fund-resi-v2 (resi-ctl-v2/->ui-data data-ctx)
            :lp-report-template.capman/real-estate-fund-stockholm-living (stockholm-living-ctl/->ui-data data-ctx)

            :lp-report-template.capman/feeder-fund (feeder-ctl/->ui-data data-ctx)
            :lp-report-template.capman/endowment-fund (endowment-ctl/->ui-data data-ctx)

            :lp-report-template.invest-europe/fund (invest-europe-fund-ctl/->ui-data data-ctx)

            :lp-report-template.voima/fund (voima-fund-ctl/->ui-data data-ctx)

            :lp-report-template.sparkmind/fund (sparkmind-fund-ctl/->ui-data data-ctx)

            :lp-report-template.innovestor/fund (innovestor-fund-ctl/->ui-data data-ctx)
            :lp-report-template.innovestor/feeder-fund (innovestor-fund-ctl/->feeder-ui-data data-ctx)
            :lp-report-template.innovestor/technology-fund (innovestor-fund-ctl/->tech-ui-data data-ctx)
            :lp-report-template.innovestor/technology-fund-v2 (innovestor-fund-ctl/->tech-ui-data data-ctx)
            :lp-report-template.lifeline/fund (lifeline-fund-ctl/->ui-data data-ctx)
            :lp-report-template.lifeline/fund-v (lifeline-fund-ctl/->ui-data data-ctx)
            :lp-report-template.lifeline/fund-vi (lifeline-fund-vi-ctl/->ui-data data-ctx)
            (do
              (js/console.error "Cannot resolve FUND template : " (pr-str report))
              nil))]
      (assoc ui-data
             :lp-report/pdf-front-page-image
             (:lp-report/pdf-front-page-image report)))))

(defn- report->ui-data
  [{:keys [holding-reports images report] :as props}]
  (let [{:lp-report/keys [template-type holdings]} report
        fund-template-data (report->fund-ui-data props)
        holding-templates
        (->> holdings
             (keep (fn [holding-id]
                     (let [holding-report (->> holding-reports
                                               (cu/filter-by :db/id holding-id)
                                               (first))]
                       (when (and holding-report
                                  (not= :lp-report-holding-template/no-reporting
                                        (:lp-report-holding/template-type holding-report)))
                         holding-report))))
             (sort lp-report-holding/compare-holdings)
             (mapv (fn [{:lp-report-holding/keys [template-type] :as holding}]
                     [template-type
                      (holding-report->ui-data
                       {:report holding
                        :images images})])))]
    {:fund-template-type template-type
     :report report
     :fund-ui-data fund-template-data
     :holding-templates holding-templates}))

(defn- report
  [{:keys [path-params]}]
  (let [{:keys [_id]} path-params]
    ;:template, :data, :result, :path-params, :path, :query-params, :parameters, :controllers
    (fn [_]
      (let [lp-report @(rf/subscribe [::sub/report-details])
            holding-reports @(rf/subscribe [::sub/holding-reports])
            report-images @(rf/subscribe [::sub/images])
            images-by-id (->> report-images
                              (map (fn [att]
                                     [(:db/id att)
                                      att]))
                              (into {}))]
        [view/report
         (report->ui-data {:report          lp-report
                           :images          images-by-id
                           :holding-reports holding-reports})]))))

(defn route-view
  ;; Don't inline this `view` function: for a reason (maybe related to the use
  ;; of multi-method), inlining it prevents navigating away from the page.
  ;; TODO investigate why we cannot inline the view function here
  [{:keys [path-params] :as view-args}]
  (rf/dispatch [::event/load-report (js/parseInt (:id path-params))])
  [report view-args])
